__turbopack_context__.v({
  "panelRight": "PanelRight-module__3A6Qtq__panelRight",
});
